import { render, staticRenderFns } from "./counterSection.vue?vue&type=template&id=193784a5&"
import script from "./counterSection.vue?vue&type=script&lang=js&"
export * from "./counterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports